import PageNav from "../components/PageNav";

export default function Product() {
	return (
		<h1>
			<PageNav />
			Product
		</h1>
	);
}
